export const resolveAssetPath = (path) => {
  if (!path) return null;
  return path.startsWith('/') || path.startsWith('http') ? path : `/${path}`;
};
